/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, MITSUB_S){
	const a = 'is-active';
	const v = 'is-visible';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></button>';
	let $path = location.pathname;


	// <ESG>下層カレント
	const esgNavCurrent = () => {
		if($('.inc_sustainability_esg_tab').length || $('.inc_sustainability_esg_tab_en').length) {
			$('.js-tabItem').each((idx, ele) => {
				if($path.indexOf($(ele).attr('href')) !== -1) {
					$(ele).addClass(a);
				}
			})
		}
		if($('.inc_sustainability_esg_bottomNav').length) {
			$('.sustainability-esg-environment-links').each((idx, ele) => {
				let thisDir = $(ele).attr('data-name');
				if($path.indexOf(thisDir) !== -1) {
					$(ele).addClass(a);
				}
			});
			if($path === '/sustainability/esg/environment/' || $path === '/sustainability/esg/environment/index.html' ||
				$path === '/sustainability/esg/social/' || $path === '/sustainability/esg/social/index.html' ||
				$path === '/sustainability/esg/governance/' || $path === '/sustainability/esg/governance/index.html') {
				$('.sustainability-esg-environment-links').removeClass(a);
			}

			$('.js-linkItem').each((idx,ele) => {
				if($path === $(ele).attr('href')) {
					$(ele).addClass(a);
				}
			});
		}
	}

	// ニュース
	const newsListLink = () => {
		let thisCat = $('.js-newsList-link').attr('data-name');
		let thisHref = $('.js-newsList-link').attr('href');

		$('.js-newsList-link').each((idx,ele) => {
			$(ele).attr('href', thisHref +'#'+ thisCat);
		});
	}

	// BCP
	const bcpPanelSlider = () => {
		if($('.js-bcp-pales').length) {
			$('.js-bcp-pales').slick({
				infinite: true,
				autoplay: true,
				slidesToShow: 4,
				slidesToScroll: 1,
				speed: 500,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				dots: false,
				responsive: [{
					breakpoint: 1025,
					settings: {
						slidesToShow: 2,
					}
				},{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					}
				}]
			});
		}
	};

	// BCP　吹き出し高さ
	const bcpBalloon = () => {
		if($('.js-bcp-balloon').length) {
			$(window).on('resize', () => {
				$('.js-bcp-balloon').css('min-height', 'auto');

				let arr = [];
				$('.js-bcp-balloon').each((idx, ele) => {
					arr.push($(ele).outerHeight());
				});
				
				let max = arr.reduce((a, b) => Math.max(a, b), -Infinity);
				$('.js-bcp-balloon').css('min-height', max);
			}).resize();
		}
	}


	// ==============================================================================
	if($('.js-newsList-link').length) {
		newsListLink();
	}
	window.onload = function(){
		esgNavCurrent();
	};
	bcpPanelSlider();
	bcpBalloon();

})(window.jQuery, window.MITSUB_S);
